import { ShipmentTableHeader } from 'constants/global';
import React from 'react'
import { Bars } from 'react-loader-spinner';
import { invoiceTableData } from './invoiceConstants';
import Pagination from 'component/pagination';
import InvoiceEmptyState from './InvoiceEmptyState';
import Table from 'component/table';

const InvoiceTable = ({
    loadingInvoice,
    downloadingInvoice,
    invoiceList,
    navigate,
    invoiceDropDownOptions,
    currentPage,
    activeTab,
    searchQuery,
    setCurrentPage,
    totalPages,
}) => {
    return (
        <div>
            {loadingInvoice || downloadingInvoice ? (
                <Bars
                    wrapperClass="w-max mx-auto mt-[100px] mb-[160px]"
                    height={30}
                    width={30}
                    color="#6F00FF"
                />
            ) : invoiceList?.length ? (
                <>
                    <Table
                        titles={ShipmentTableHeader}
                        rows={invoiceList?.map((invoice, index) => {
                            return invoiceTableData({
                                invoice,
                                index,
                                navigate,
                                invoiceDropDownOptions,
                            });
                        })}
                        wrapperClassName="shadow-none"
                    />
                    <div className="flex items-center justify-center w-full mx-auto bottom-1">
                        <Pagination
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            totalPages={totalPages}
                        />
                    </div>
                </>
            ) : (
                <InvoiceEmptyState activeTab={activeTab} searchQuery={searchQuery} />
            )}
        </div>
    );
};

export default InvoiceTable